import { createContext } from 'react';

export const TEMPLATE_CONTEXT = createContext();
export const TemplateContextProvider = TEMPLATE_CONTEXT.Provider;

export default { TemplateContextProvider, TEMPLATE_CONTEXT };
